module.exports = __webpack_public_path__ + "static/media/search-solid.71b272f5.svg";